module.exports = __webpack_public_path__ + "static/media/BulletProofWarrior.1fc5e1b0.jpg";